import http from '~/http/services/pos';
import { ApiResponse } from '~/types/Api';
import { ClosingReport } from '~/types/Report';

type ClosingReportResposne = ApiResponse<ClosingReport>;
type PrintClosingReportResponse = ApiResponse<null>;
type PrintSoldItemsReportResponse = ApiResponse<null>;

export const fetchClosingReport = (id: string) => {
  return http.get<ClosingReportResposne>(`/api/v1/report/closing/${id}`);
};

export const printClosingReport = (id: string) => {
  return http.get<PrintClosingReportResponse>(
    `/api/v1/report/closing/${id}/print`
  );
};

export const printSoldItemsReport = (id: string) => {
  return http.get<PrintSoldItemsReportResponse>(
    `/api/v1/report/closing/${id}/sold-items/print`
  );
};
